import { render, staticRenderFns } from "./appropriations.vue?vue&type=template&id=2a4fbd40&"
import script from "./appropriations.vue?vue&type=script&lang=js&"
export * from "./appropriations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports